import React from 'react'

const PageNotFound: React.FC = () => {
	return (<>404</>)
}

export default PageNotFound;